module.exports = __webpack_public_path__ + "my-team.5617bfe068fa0545a7f3.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/my-team.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/my-team.svg
// module chunks = styles